<div class="unauthorised">
    <span class="unauthorised-message">This page is unauthorised.</span>
    <ng-container *ngIf="roleId != 0 || roleId != null">
        <p>
            <span><a href="/">Please click here for dashboard</a></span>
        </p>
    </ng-container>
</div>